<template>
  <IonAlert
    :is-open="true"
    header="Sorry, something went wrong"
    message="You We have been notified and will fix it as soon as possible."
    :buttons="['OK']"
  />
</template>
